<template>
			<div id="page-content">
				<div id="log-in">
				
					<div id="supplierinfo" class="col-md-8">
						<h1>Become our Supplier</h1>
						<ul>
							<li>Post your products</li>
							<li>Get notifications and feedbacks about your products</li>
						</ul>
					</div>
					
					<div id="login" class="col-md-4">
						<h1>Log in</h1>
						
						<form v-on:submit.prevent="login">
							<input type="text" name="username" placeholder="Username" />
							<input type="password" name="password" placeholder="Password" />
							<input type="hidden" name="token" :value="token" />
							<button type="submit">Log in</button>
							<div id="message"></div>
						</form>
						
						<p>Not yet a member? <router-link to="/account-selection" class="font-link floatright">Sign up!</router-link></p>
					</div>
					
				</div>
			</div>
</template>

<script>
	export default{
		props: ['issessionset'],
		data(){
			return{
				token: ''
			}
		},
		methods: {
			login: function(event){
				var self = this;
				var data = $(event.target).serialize();

				$.ajax({
					url: 'static/php/login.php',
					type: 'post',
					data: data,
					success: function(data){
						if(data == 1){
							self.$emit('session', true);
							self.$router.push({path: '/user'});
						}else{
							$('#message').html(data);
							$.ajax({
								url: 'static/php/gettoken.php',
								success: function(data){
									if(typeof data === "string"){
										self.token = data;
									}
								}
							});
						}
					}
				});
			}
		},
		created(){
			var self = this;
			if(this.issessionset === true){
				this.$router.push({path: '/user'});
			}else{
				$.ajax({
					url: 'static/php/gettoken.php',
					success: function(data){
						if(typeof data === "string"){
							self.token = data;
						}
					}
				});
			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		},
		watch: {
			issessionset: function(newval){
				if(newval === true){
					this.$router.push({path: '/user'});
				}		
			}
		}
		//rename user - userreceipts
	}
</script>


// WEBPACK FOOTER //
// Login.vue?b4dbbc4c